import CryptoJS from 'crypto-js';

class EncryptionService {
  constructor() {
    // In production, this should be fetched from the server or stored securely
    // For now, using the same key as backend (should be synced through secure channel)
    this.secretKey = process.env.REACT_APP_MESSAGE_ENCRYPTION_KEY || 'FALLBACK_KEY_REPLACE_IN_PRODUCTION';
  }

  encrypt(text) {
    if (!text) return null;
    try {
      const encrypted = CryptoJS.AES.encrypt(text, this.secretKey).toString();
      return encrypted;
    } catch (error) {
      console.error('Encryption error:', error);
      throw new Error('Failed to encrypt message');
    }
  }

  decrypt(encryptedText) {
    if (!encryptedText) return null;
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedText, this.secretKey);
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Decryption error:', error);
      throw new Error('Failed to decrypt message');
    }
  }

  encryptObject(obj) {
    if (!obj) return null;
    try {
      const jsonString = JSON.stringify(obj);
      return this.encrypt(jsonString);
    } catch (error) {
      console.error('Object encryption error:', error);
      throw new Error('Failed to encrypt object');
    }
  }

  decryptObject(encryptedText) {
    if (!encryptedText) return null;
    try {
      const decrypted = this.decrypt(encryptedText);
      return JSON.parse(decrypted);
    } catch (error) {
      console.error('Object decryption error:', error);
      throw new Error('Failed to decrypt object');
    }
  }

  generateHash(text) {
    return CryptoJS.SHA256(text).toString();
  }
}

export default new EncryptionService();